/*
 * Attribution beacon — Memento Exclusives (Shopify theme asset).
 *
 * On a Klaviyo form submit, POSTs the enquiry + full attribution to the Cloud Run
 * /webhooks/forms endpoint. Fully self-contained: its own localStorage key +
 * session cookie ('mem_v2_*'), reads (never writes) the shared ad cookies.
 */
(function () {
  // ── config ─────────────────────────────────────────────────────────────────
  var WEBHOOK_BASE_URL = 'https://mondayleadsimport-33004583292.europe-west1.run.app/webhooks/forms';

  // Dedicated PUBLIC forms token (FORMS_PUBLIC_TOKEN on the service). Public by
  // design — it authenticates a browser, not a trusted server.
  var WEBHOOK_TOKEN = 'memf1a_lUSxF0eay4JMkipZQhQ3ID3a40GTSEa1';

  var ALLOWED_FORM_IDS = ['XRg8A7', 'Tzcj4F', 'UbABU4', 'Vt9aLM', 'SEWwab'];
  var STORAGE_KEY = 'mem_v2_attribution';   // namespaced — never the old key
  var SESSION_KEY = 'mem_v2_session';
  var COOKIE_DAYS = 90;
  var SESSION_MINUTES = 30;
  var FIRST_TOUCH_TTL_MS = COOKIE_DAYS * 24 * 60 * 60 * 1000;
  var MAX_JOURNEY = 20;

  var TRACKING_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'gclid', 'qwerty', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'li_fat_id'
  ];
  var FIRST_TOUCH_UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var FIRST_TOUCH_FIELDS = [
    'landing_page', 'landing_referrer', 'first_seen_at',
    'first_utm_source', 'first_utm_medium', 'first_utm_campaign',
    'first_utm_content', 'first_utm_term'
  ];

  // ── consent ─────────────────────────────────────────────────────────────────
  function marketingConsentAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.marketingAllowed !== 'function') return false;
    try { return !!cp.marketingAllowed(); } catch (e) { return false; }
  }

  // ── primitives ──────────────────────────────────────────────────────────────
  function sanitize(value) {
    if (!value) return '';
    return String(value).trim().replace(/[<>"'`]/g, '').substring(0, 255);
  }

  function getWebhookUrl() {
    return WEBHOOK_BASE_URL + '?token=' + encodeURIComponent(WEBHOOK_TOKEN);
  }

  function getCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[2]) : '';
    } catch (e) { return ''; }
  }

  // Only the OWN namespaced session cookie is ever written.
  function setSessionCookie(minutes) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + minutes * 60 * 1000);
      document.cookie = SESSION_KEY + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    } catch (e) {}
  }

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      var p = JSON.parse(raw);
      return p && typeof p === 'object' ? p : {};
    } catch (e) { return {}; }
  }

  function writeStored(data) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function clearStored() {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    try { document.cookie = SESSION_KEY + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax'; } catch (e) {}
  }

  // ── durable join keys (Stape / GA4 / Clarity) ───────────────────────────────
  function getGaClientId() {
    var raw = getCookie('_ga');
    if (!raw) return '';
    var parts = raw.split('.');
    if (parts.length < 4) return '';
    return sanitize(parts.slice(2).join('.'));
  }

  function getStapeUserId() {
    var c = getCookie('stapeUserId');
    if (c) return sanitize(c);
    try { var ls = window.localStorage.getItem('stapeUserId'); if (ls) return sanitize(ls); } catch (e) {}
    // The durable Stape cookie is httpOnly (server-side Cookie Keeper), so JS can't
    // read it — pick it up from the sGTM dataLayer when Stape exposes it there.
    try {
      var dl = window.dataLayer || [];
      for (var i = dl.length - 1; i >= 0; i--) {
        var v = dl[i] && (dl[i].stapeUserId || dl[i].stape_user_id || dl[i].stape_id);
        if (v) return sanitize(v);
      }
    } catch (e) {}
    return '';
  }

  // Microsoft Clarity user id (persisted in the _clck cookie as "<id>|...").
  function getClarityId() {
    var c = getCookie('_clck');
    if (!c) return '';
    return sanitize(c.split('|')[0].split('^')[0].split('%')[0]);
  }
  // Tag the CURRENT Clarity session with the customer so it's searchable by them.
  function identifyClarity(email) {
    try { if (window.clarity && email) window.clarity('identify', String(email)); } catch (e) {}
  }

  function parseGcl(name) {
    var raw = getCookie(name);
    if (!raw) return '';
    var parts = raw.split('.');
    if (parts.length < 3) return '';
    return sanitize(parts.slice(2).join('.'));
  }

  function getFacebookAttribution(params) {
    var fbp = sanitize(getCookie('_fbp'));
    var fbc = sanitize(getCookie('_fbc'));
    var fbclid = sanitize(params.get('fbclid'));
    if (!fbc && fbclid) fbc = 'fb.1.' + Date.now() + '.' + fbclid;
    return { fbp: fbp, fbc: fbc };
  }

  function getTrackingValue(key, params, stored) {
    var live = sanitize(params.get(key));
    if (live) return live;
    var cookieValue = sanitize(getCookie(key));   // read-only (old script mirrors these)
    if (cookieValue) return cookieValue;
    if (key === 'gclid') { var g = parseGcl('_gcl_aw'); if (g) return g; }
    else if (key === 'gbraid') { var gb = parseGcl('_gcl_gb'); if (gb) return gb; }
    else if (key === 'wbraid') { var dc = parseGcl('_gcl_dc'); if (dc) return dc; }
    return sanitize(stored[key]);
  }

  // ── channel derivation ──────────────────────────────────────────────────────
  function deriveChannel(params) {
    var s = sanitize(params.get('utm_source'));
    var m = sanitize(params.get('utm_medium'));
    var c = sanitize(params.get('utm_campaign'));
    if (s || m || c) return { src: s, med: m, cmp: c };
    if (params.get('gclid') || params.get('gbraid') || params.get('wbraid') || getCookie('_gcl_aw')) return { src: 'google', med: 'cpc', cmp: '' };
    if (params.get('fbclid')) return { src: 'facebook', med: 'paid', cmp: '' };
    if (params.get('msclkid')) return { src: 'bing', med: 'cpc', cmp: '' };
    if (params.get('li_fat_id')) return { src: 'linkedin', med: 'paid', cmp: '' };
    var ref = document.referrer || '';
    if (ref) {
      try {
        var host = new URL(ref).hostname;
        if (host && host !== window.location.hostname) return { src: host, med: 'referral', cmp: '' };
      } catch (e) {}
    }
    return { src: '(direct)', med: '(none)', cmp: '' };
  }

  // ── first-touch (sticky, write-once) ────────────────────────────────────────
  function firstTouchIsFresh(stored) {
    try {
      var seen = stored && stored.first_seen_at;
      if (!seen) return false;
      var ts = Date.parse(seen);
      if (isNaN(ts)) return false;
      return Date.now() - ts <= FIRST_TOUCH_TTL_MS;
    } catch (e) { return false; }
  }

  function stripFirstTouch(o) { for (var i = 0; i < FIRST_TOUCH_FIELDS.length; i++) delete o[FIRST_TOUCH_FIELDS[i]]; }

  function captureFirstTouch(params, next) {
    var changed = false;
    if (next.first_seen_at && !firstTouchIsFresh(next)) { stripFirstTouch(next); changed = true; }
    if (!next.first_seen_at) {
      next.landing_page = sanitize(window.location.href);
      next.landing_referrer = sanitize(document.referrer || '');
      next.first_seen_at = new Date().toISOString();
      for (var i = 0; i < FIRST_TOUCH_UTM_KEYS.length; i++) {
        var k = FIRST_TOUCH_UTM_KEYS[i], v = sanitize(params.get(k));
        if (v) next['first_' + k] = v;
      }
      changed = true;
    }
    return changed;
  }

  // ── journey (multi-visit) ───────────────────────────────────────────────────
  function recordVisit(params, next) {
    var hasSession = !!getCookie(SESSION_KEY);
    setSessionCookie(SESSION_MINUTES);
    if (hasSession) return false;
    var ch = deriveChannel(params);
    var entry = {
      t: new Date().toISOString(), src: ch.src, med: ch.med, cmp: ch.cmp,
      lp: sanitize(window.location.pathname), ref: sanitize(document.referrer || '')
    };
    next.journey = Array.isArray(next.journey) ? next.journey.slice() : [];
    next.journey.push(entry);
    if (next.journey.length > MAX_JOURNEY) next.journey = next.journey.slice(next.journey.length - MAX_JOURNEY);
    return true;
  }

  // If the current URL carries no UTM but the referrer does, fold the referrer's
  // UTM in so first-touch, journey and last-touch all attribute to the campaign.
  function withReferrerUtm(params) {
    if (params.get('utm_source') || params.get('utm_medium') || params.get('utm_campaign')) return params;
    var ref = document.referrer || '';
    if (ref.indexOf('utm_') === -1) return params;
    try {
      var refParams = new URL(ref).searchParams;
      for (var i = 0; i < FIRST_TOUCH_UTM_KEYS.length; i++) {
        var k = FIRST_TOUCH_UTM_KEYS[i], v = sanitize(refParams.get(k));
        if (v && !params.get(k)) params.set(k, v);
      }
    } catch (e) {}
    return params;
  }

  // ── capture (consent-gated, own storage only) ───────────────────────────────
  function capture() {
    if (!marketingConsentAllowed()) return;
    var params = withReferrerUtm(new URLSearchParams(window.location.search));
    var stored = readStored();
    var next = Object.assign({}, stored);
    var changed = false;

    TRACKING_KEYS.forEach(function (key) {
      var value = sanitize(params.get(key)) || sanitize(getCookie(key));
      if (value && next[key] !== value) { next[key] = value; changed = true; }
    });

    var fb = getFacebookAttribution(params);
    if (fb.fbp && next.fbp !== fb.fbp) { next.fbp = fb.fbp; changed = true; }
    if (fb.fbc && next.fbc !== fb.fbc) { next.fbc = fb.fbc; changed = true; }

    if (captureFirstTouch(params, next)) changed = true;
    if (recordVisit(params, next)) changed = true;
    if (changed) writeStored(next);
  }

  // Coarse, non-identifying device class + timezone — safe to send even without
  // marketing consent. Device → Preferred Device column; timezone → rough country.
  function detectDevice() {
    try {
      var ua = navigator.userAgent || '';
      if (/iPad|Tablet|PlayBook|Silk|(Android(?!.*Mobile))/i.test(ua)) return 'Tablet';
      if (/Mobi|iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry|IEMobile/i.test(ua)) return 'Mobile';
      return 'Desktop';
    } catch (e) { return ''; }
  }

  // OEM/OS hint → Preferred Device Brand (Monday status labels). Order is
  // deliberate: named OEMs before generic Android/Windows catch-alls.
  // Board spelling "Xiomi" (not Xiaomi) must be sent exactly.
  function detectDeviceBrand() {
    try {
      var ua = navigator.userAgent || '';
      if (!ua) return '';
      if (/iPhone|iPad|iPod|Macintosh/i.test(ua)) return 'Apple';
      if (/Samsung|\bSM-[A-Z0-9]+/i.test(ua)) return 'Samsung';
      if (/Huawei|\bHonor\b/i.test(ua)) return 'Huawei';
      if (/Xiaomi|Redmi|\bPOCO\b|\bMi\s?\d/i.test(ua)) return 'Xiomi';
      if (/Pixel|CrOS|Chrome OS/i.test(ua)) return 'Google';
      if (/Windows Phone|Windows NT|Win64|WOW64/i.test(ua)) return 'Microsoft';
      if (/Android/i.test(ua)) return 'Other';
      return 'Other';
    } catch (e) { return ''; }
  }

  function detectTimezone() {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; }
  }

  // ── payload ─────────────────────────────────────────────────────────────────
  function buildPayload(detail) {
    var consented = marketingConsentAllowed();
    var params = new URLSearchParams(window.location.search);
    var stored = readStored();

    var payload = {
      formId: sanitize(detail.formId || detail.formID || ''),
      companyId: sanitize(detail.companyId || ''),
      eventType: sanitize(detail.type || ''),
      submittedAt: new Date().toISOString(),
      pagePath: window.location.pathname,
      pageTitle: document.title || '',
      metaData: detail.metaData || {}
    };

    var dev = detectDevice(); if (dev) payload.device = dev;
    var brand = detectDeviceBrand(); if (brand) payload.device_brand = brand;
    var tz = detectTimezone(); if (tz) payload.tz = tz;

    if (!consented) {
      payload.pageUrl = window.location.origin + window.location.pathname;
      payload.referrer = '';
      return payload;
    }

    payload.pageUrl = window.location.href;
    payload.referrer = document.referrer || '';

    TRACKING_KEYS.forEach(function (key) {
      var value = getTrackingValue(key, params, stored);
      if (value) payload[key] = value;
    });

    var fb = getFacebookAttribution(params);
    payload.fbp = sanitize(getCookie('_fbp')) || sanitize(stored.fbp) || fb.fbp;
    payload.fbc = sanitize(getCookie('_fbc')) || sanitize(stored.fbc) || fb.fbc;
    if (!payload.fbp) delete payload.fbp;
    if (!payload.fbc) delete payload.fbc;

    var gaId = getGaClientId(); if (gaId) payload.ga_client_id = gaId;
    var stapeId = getStapeUserId(); if (stapeId) payload.stape_user_id = stapeId;
    var clarityId = getClarityId(); if (clarityId) payload.clarity_id = clarityId;
    // Tag this Clarity session with the customer's email so it's replayable by them.
    var md = detail.metaData || {};
    identifyClarity(md['$email'] || md['email']);

    if (firstTouchIsFresh(stored)) {
      if (stored.landing_page) payload.landing_page = sanitize(stored.landing_page);
      if (stored.landing_referrer) payload.landing_referrer = sanitize(stored.landing_referrer);
      if (stored.first_seen_at) payload.first_seen_at = sanitize(stored.first_seen_at);
      for (var i = 0; i < FIRST_TOUCH_UTM_KEYS.length; i++) {
        var fk = 'first_' + FIRST_TOUCH_UTM_KEYS[i];
        if (stored[fk]) payload[fk] = sanitize(stored[fk]);
      }
    }

    if (Array.isArray(stored.journey) && stored.journey.length) {
      payload.journey = stored.journey.slice(0, MAX_JOURNEY);
    }

    return payload;
  }

  function sendWebhook(payload) {
    try {
      fetch(getWebhookUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  function handleKlaviyoSubmit(event) {
    if (!event || !event.detail || event.detail.type !== 'submit') return;
    var formId = String(event.detail.formId || event.detail.formID || '').trim();
    if (ALLOWED_FORM_IDS.indexOf(formId) === -1) return;
    try { sendWebhook(buildPayload(event.detail)); } catch (e) {}
  }

  function init() {
    capture();
    window.addEventListener('klaviyoForms', handleKlaviyoSubmit);
    document.addEventListener('visitorConsentCollected', function () {
      if (marketingConsentAllowed()) capture(); else clearStored();
    });
    // Shopify's Customer Privacy API loads AFTER the page. Poll until consent is
    // available, then capture once so first-touch/journey land on the real landing page.
    var tries = 0;
    var ready = setInterval(function () {
      if (marketingConsentAllowed()) { clearInterval(ready); capture(); }
      else if (++tries >= 25) { clearInterval(ready); }   // ~5s then give up
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
